<template>
  <template v-if="editionMode">
    <label
      class="align-center flex flex-col rounded-md border border-slate-300 shadow-sm select-none focus-within:border-indigo-600 focus-within:ring-1 focus-within:ring-indigo-600 dark:border dark:border-white dark:bg-slate-500 dark:text-white"
      :class="{
        'mt-2': !noMarginTop,
        'bg-primary-500': checked && !disabled,
        'text-white': checked,
        'text-gray-900': !checked,
        'cursor-pointer': !disabled,
        'disabled bg-gray-100': disabled,
        'w-full px-3 py-2': localSize === 'large',
        'px-3 py-2': localSize === 'medium',
        'px-2 py-1.5': localSize === 'small',
        'px-1.5 py-1': localSize === 'extra-small'
      }"
    >
      <span class="flex w-full flex-row items-center gap-2">
        <FontAwesomeIcon :icon="['far', checked ? 'circle-check' : 'circle']" />
        <span class="block truncate first-letter:uppercase">
          {{ label }}&nbsp;
        </span>
        <span v-if="label && required" class="text-red-600">*</span>
      </span>
      <span
        v-if="description"
        class="pointer-events-none text-[11px] first-letter:uppercase"
        :class="{
          'text-black/60': !checked,
          'text-white/80': checked
        }"
        v-html="description"
      ></span>
      <input
        v-model="localModelValue"
        class="hidden w-0"
        type="checkbox"
        :name="name"
        :disabled="disabled"
        :value="value"
        :data-testid="name ? `wysiwyg-${name}` : undefined"
      />
    </label>
    <div
      v-for="(error, index) in errors"
      :key="index"
      class="form-help text-red-600"
    >
      {{ $t(error, { attribute: $t('attributes.' + name) }) }}
    </div>
  </template>
  <template v-else>
    <div
      class="align-center flex flex-col rounded-md border border-slate-300 shadow-sm select-none focus-within:border-indigo-600 focus-within:ring-1 focus-within:ring-indigo-600 dark:border dark:border-white dark:bg-slate-500 dark:text-white"
      :class="{
        'mt-2': !noMarginTop,
        'bg-primary-500': checked && !disabled,
        'text-white': checked,
        'text-gray-900': !checked,
        'disabled bg-gray-100': disabled,
        'w-full px-3 py-2': localSize === 'large',
        'px-3 py-2': localSize === 'medium',
        'px-2 py-1.5': localSize === 'small',
        'px-1.5 py-1': localSize === 'extra-small'
      }"
    >
      <span class="flex w-full flex-row items-center gap-2">
        <FontAwesomeIcon :icon="['far', checked ? 'circle-check' : 'circle']" />
        <span class="block truncate first-letter:uppercase">
          {{ label }}
        </span>
      </span>

      <span
        v-if="description"
        class="pointer-events-none mt-1 text-[11px] first-letter:uppercase"
        :class="{
          'text-black/60': !checked,
          'text-white/80': checked
        }"
        v-html="description"
      ></span>
    </div>
  </template>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'BaseCheckBox',
  components: { FontAwesomeIcon },
  props: {
    modelValue: {
      type: [String, Number, Boolean],
      required: true
    },
    value: {
      type: [String, Number, Boolean],
      required: false,
      default: undefined
    },
    label: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: false,
      default: null
    },
    errors: {
      type: Object,
      required: false,
      default: null
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    editionMode: {
      type: Boolean,
      required: false,
      default: false
    },
    noMarginTop: {
      type: Boolean,
      required: false,
      default: false
    },
    size: {
      type: String,
      required: false,
      default: 'medium',
      validator: (value) =>
        ['extra-small', 'small', 'medium', 'large', 'extra-large'].indexOf(
          value
        ) !== -1
    },
    name: {
      type: String,
      required: true
    }
  },
  emits: ['change', 'update:modelValue'],
  computed: {
    localModelValue: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
        this.$emit('change', value)
      }
    },
    checked() {
      return this.value ? this.modelValue.includes(this.value) : this.modelValue
    },
    localSize() {
      return this.size
    }
  }
}
</script>
